//Utility functions
import moment from "moment";
import _ from "lodash";

export default {
	generateUUID() {
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
			c
		) {
			var r = (Math.random() * 16) | 0,
				v = c == "x" ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	},

	diff(object, base) {
		function changes(object, base) {
			return _.transform(object, function(result, value, key) {
				if (!_.isEqual(value, base[key])) {
					result[key] =
						_.isObject(value) && _.isObject(base[key])
							? changes(value, base[key])
							: value;
				}
			});
		}
		return changes(object, base);
	},

	truncateString(str, length) {
		var trimmable =
			"\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF";
		var reg = new RegExp("(?=[" + trimmable + "])");
		var words = str.split(reg);
		var count = 0;
		var result = words
			.filter(function(word) {
				count += word.length;
				return count <= length;
			})
			.join("");
		if (result !== str) {
			result += "...";
		}
		return result;
	},

	isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	},

	getTimeString(seconds) {
		return moment()
			.startOf("day")
			.seconds(seconds)
			.format("H:mm:ss");
	},

	throttleMathJAX: _.debounce(() => {
		console.log("MathJAX Init");
		MathJax.Hub.Typeset();
	}, 200)
};



// WEBPACK FOOTER //
// ./src/services/Utils.js